"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CircleCheck, Phone, Calendar } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MassageHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="244926" id="מטפל-סיעודי-בראשון-לציון-פתרון-מיידי" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground font-default leading-tight">
                מטפל סיעודי בראשון לציון <br className="hidden md:block" />
                <span className="text-primary">| פתרון מיידי תוך 5 שעות</span>
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-[600px]">
                זקוקים לעזרה דחופה? אנו מספקים שירותי סיעוד מקצועיים בראשון לציון והסביבה, עם התחייבות למענה מהיר ואיכותי לכל צורך רפואי או שיקומי.
              </p>
            </div>

            <div className="bg-muted/50 rounded-2xl p-6 md:p-8 border border-border">
              <h2 className="text-2xl font-semibold text-foreground font-default mb-6">
                שירותי סיעוד מותאמים אישית בראשון לציון
              </h2>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="bg-background p-2 rounded-full h-fit shadow-sm border border-border shrink-0">
                    <CircleCheck className="size-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg font-default text-foreground mb-1">
                      <Link to="/CaregiverServicePagesPage" className="hover:text-primary transition-colors">מטפל סיעודי בבית</Link>
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      ליווי צמוד בסביבה המוכרת והבטוחה של המטופל. סיוע בפעולות יומיומיות, השגחה רפואית ותמיכה רגשית מקצועית לאורך כל שעות היממה.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="bg-background p-2 rounded-full h-fit shadow-sm border border-border shrink-0">
                    <CircleCheck className="size-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg font-default text-foreground mb-1">
                      <Link to="/CaregiverServicePagesPage2" className="hover:text-primary transition-colors">השגחה בבית חולים</Link>
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      שירותי השגחה פרטית בבתי החולים באזור ראשון לציון. אנחנו כאן כדי לוודא שהיקיר שלכם מקבל את מלוא תשומת הלב והטיפול המגיע לו.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button size="lg" className="h-14 px-8 text-base bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg shadow-md" asChild>
                <Link to="/ContactPage">
                  <SafeHydrate><Calendar className="ml-2 size-5" /></SafeHydrate>
                  הזמנת מטפל עכשיו
                </Link>
              </Button>
              <Button variant="outline" size="lg" className="h-14 px-8 text-base border-primary text-primary hover:bg-accent rounded-lg shadow-sm" asChild>
                <Link to="tel:03-1234567">
                  <Phone className="ml-2 size-5" />
                  שיחת ייעוץ חינם
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative lg:h-[700px] rounded-3xl overflow-hidden shadow-2xl border border-border/50 group">
            <div className="absolute inset-0 bg-primary/5 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_rishon_lezion.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_rishon_lezion.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_rishon_lezion.png-wvc-sizes" alt="מטפל סיעודי מקצועי בראשון לציון מעניק טיפול מסור" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" loading="eager" />
            
            {}
            <div className="absolute bottom-8 left-8 right-8 bg-background/95 backdrop-blur-sm p-6 rounded-2xl shadow-lg border border-border z-20 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-foreground font-default text-lg">זמינות מיידית בראשון לציון</p>
                  <p className="text-sm text-muted-foreground">צוות מטפלים בפריסה עירונית רחבה</p>
                </div>
                <div className="bg-primary/10 p-3 rounded-full">
                  <CircleCheck className="size-6 text-primary" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}